import React from 'react';

export function VipName({ user }) {
  if (!user) return null;

  const nameStyle = {
    color: user.isVip && user.customNameColor ? user.customNameColor : 'inherit',
    fontWeight: user.isVip ? '700' : '500',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px'
  };

  return (
    <span style={nameStyle} className={user.isVip ? 'vip-glow-text' : ''}>
      {user.nickname || user.username || user.firstName || 'مستخدم مجهول'}
      {user.isVip && (
        <span className="vip-badge-tag" title="عضو مميز VIP">
          👑 VIP
        </span>
      )}
    </span>
  );
}
